import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";
import Tabs from "@/components/Tabs.vue";
import PageHeaderProject from "@/components/PageHeaderProject.vue";
import useProjectNav from "@/composables/useProjectNav";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectBudget',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const projectId = ref();
onMounted(() => {
  projectId.value = props.id;
});

const { subTabs } = useProjectNav(projectId);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderProject, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
      default: _withCtx(() => [
        (_unref(subTabs))
          ? (_openBlock(), _createBlock(Tabs, {
              key: 0,
              definitions: _unref(subTabs),
              color: "primary",
              size: "sm"
            }, null, 8, ["definitions"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(_component_router_view, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), null, 16)
  ], 64))
}
}

})